import * as _ from 'lodash';
import { WorkItemBase } from './workitem-base-model';
import { WorkItemTypes } from 'common/workitems/constants/workitem-types';
import { LensItem } from '../interfaces/lens.interface';

export class WorkItemLens extends WorkItemBase implements LensItem {
  public readonly type: string = WorkItemTypes.LENS;
  public elmRoute: string;

  constructor(workItem) {
    super(workItem);

    this.decorateWithDefaultValues(workItem);

    this._isCollapsible = false;
    this.isClosable = false;
    this.keepAlive = true;
  }

  decorateWithDefaultValues(values) {
    // TODO: use a private property for the model and create getters to this private model
    _.assign(this, values);
  }
}
